import { onMounted, onUnmounted, ref } from 'vue';
export function useGeolocation() {
  const coords = ref({ latitude: 0, longitude: 0, error: false });
  const isSupported = 'navigator' in window && 'geolocation' in navigator;
  const options = {
    enableHighAccuracy: false,
    // timeout: 5000,
    maximumAge: 0,
  };
  const error = (error) => {
    coords.value.error = true;
  };
  let watcher = null;

  onMounted(() => {
    if (isSupported) {
      watcher = navigator.geolocation.getCurrentPosition(
        (position) => {
          coords.value = position.coords;
          //47.886421417985765, 106.90573858098497s
        },
        error,
        options
      );
    } else {
      console.log('no support');
    }
  });
  onUnmounted(() => {
    if (watcher) navigator.geolocation.clearWatch(watcher);
  });
  return { coords, isSupported };
}
